import { cva } from 'class-variance-authority';
import type { PillColorsEnum } from '../types';

const decoratorVariants = cva('flex-shrink-0', {
  variants: {
    variant: {
      soft: '',
      clear: '',
      solid: 'text-white',
      subtle: '',
      ghost: '',
      outlined: '',
    },
    color: {
      gray: 'text-utility-gray-700',
      brand: 'text-utility-brand-700',
      error: 'text-utility-error-700',
      warning: 'text-utility-warning-700',
      success: 'text-utility-success-700',
      blue: 'text-utility-blue-700',
      purple: 'text-utility-purple-700',
      fuchsia: 'text-utility-fuchsia-700',
      cyan: 'text-utility-cyan-700',
      lime: 'text-utility-lime-700',
      pink: 'text-utility-pink-700',
      violet: 'text-utility-violet-700',
      indigo: 'text-utility-indigo-700',
      rose: 'text-utility-rose-700',
      yellow: 'text-utility-warning-300',
      blueDark: 'text-utility-blue-dark-700',
    } satisfies Record<PillColorsEnum, string>,
    size: {
      md: 'w-xl h-xl',
      sm: 'w-lg h-lg',
      xs: 'w-lg h-lg',
      xxs: 'w-lg h-lg',
    },
  },
});

export default decoratorVariants;
